import amex from '../../../svg/component/paymentOptions/amex.svg';
import diners from '../../../svg/component/paymentOptions/diners.svg';
import discover from '../../../svg/component/paymentOptions/discover.svg';
import jcb from '../../../svg/component/paymentOptions/jcb.svg';
import maestro from '../../../svg/component/paymentOptions/maestro.svg';
import mastercard from '../../../svg/component/paymentOptions/mastercard.svg';
import one4all from '../../../svg/component/paymentOptions/one4all.svg';
import unionpay from '../../../svg/component/paymentOptions/unionpay.svg';
import visaCredit from '../../../svg/component/paymentOptions/visa-credit.svg';
import visaElectron from '../../../svg/component/paymentOptions/visa-electron.svg';

// default card fallback & specific card types
const defaultCardType = {
  name: 'unknown',
  iconName: '',
};

const cardTypeByPrefixes = [
  {
    prefix: ['484426'],
    type: {
      iconName: 'one4all',
      icon: one4all,
      cv2Length: 3,
      fixedLength: [16],
    },
  },
  {
    prefix: ['417500', '4026', '4508', '4844', '4913', '4917'],
    type: {
      iconName: 'visa-electron',
      icon: visaElectron,
      cv2Length: 3,
      fixedLength: [16],
    },
  },
  {
    prefix: ['2184', '4903', '4905', '4911', '4936', '5000', '5001', '5002', '5003', '5004', '5005', '5006',
      '5007', '5010', '5011', '5013', '5014', '5015', '5016', '5017', '5018', '502', '503', '504', '5054', '5055',
      '5056', '5057', '5058', '5060', '5069', '5076', '5077', '5081', '5082', '5600', '5602', '5605', '5606',
      '5607', '5608', '5609', '5610', '5611', '5612', '5622', '5624', '5630', '5633', '5635', '5636', '5641',
      '5642', '5643', '564182', '5651', '5662', '5663', '5664', '5665', '5666', '5667', '5668', '5669', '5670',
      '5671', '5672', '5674', '5675', '5676', '5677', '5678', '5679', '568', '570', '5710', '5716', '5717', '5719',
      '572', '5731', '5732', '5733', '5742', '5745', '5748', '5749', '5752', '5753', '5754', '5755', '5756', '5757',
      '5768', '577', '5780', '5781', '5782', '579', '5800', '5801', '5802', '5803', '5804', '5809', '581', '582',
      '583', '584', '585', '586', '587', '588', '589', '6002', '6003', '6007', '6009', '601', '6020', '6026', '6029',
      '603', '6044', '6045', '6047', '6048', '6049', '6050', '6051', '6058', '6060', '6061', '6062', '6063', '6064',
      '6086', '6087', '6167', '6218', '6219', '6220', '6221', '627', '6280', '6281', '6294', '6301', '6304', '633110',
      '6333', '6334', '6338', '6360', '6361', '6363', '6365', '6367', '6370', '6371', '6375', '639', '640', '6410',
      '6413', '6414', '6418', '6420', '6421', '6422', '6423', '6424', '6425', '6700', '6703', '6705', '6706', '6708',
      '6709', '6710', '6711', '6712', '6713', '6720', '6722', '6725', '6726', '6729', '6730', '6731', '6732', '6733',
      '6734', '6735', '6736', '6737', '6739', '6743', '6744', '6745', '6746', '6747', '6748', '6750', '6757', '6759',
      '6760', '6761', '6762', '6763', '6764', '6765', '6766', '6767', '6768', '6769', '677', '6784', '6787', '6789',
      '6790', '6791', '6797', '6798', '6799', '7083', '8229', '8496'],
    type: {
      iconName: 'maestro',
      icon: maestro,
      cv2Length: 3,
      minLength: 12,
      maxLength: 19,
    },
  },
  {
    prefix: ['2221', '2222', '2223', '2224', '2225', '2226', '2227', '2228', '2229', '2720',
      '223', '224', '225', '226', '227', '228', '229', '270', '271',
      '23', '24', '25', '26', '51', '52', '53', '54', '55'],
    type: {
      iconName: 'mastercard',
      icon: mastercard,
      cv2Length: 3,
      fixedLength: [16],
    },
  },
  {
    prefix: ['6011', '644', '645', '646', '647', '648', '649', '65'],
    type: {
      iconName: 'discover',
      icon: discover,
      cv2Length: 3,
      fixedLength: [16, 19],
    },
  },
  {
    prefix: ['622', '624', '625', '626', '628'],
    type: {
      iconName: 'unionpay',
      icon: unionpay,
      cv2Length: 3,
      minLength: 16,
      maxLength: 19,
    },
  },
  {
    prefix: ['300', '301', '302', '303', '304', '305', '309', '36', '38', '39'],
    type: {
      iconName: 'diners',
      icon: diners,
      cv2Length: 3,
      minLength: 14,
      maxLength: 15,
    },
  },
  {
    prefix: ['34', '37'],
    type: {
      iconName: 'amex',
      icon: amex,
      cv2Length: 4,
      fixedLength: [15],
    },
  },
  {
    prefix: ['35'],
    type: {
      iconName: 'jcb',
      icon: jcb,
      cv2Length: 3,
      fixedLength: [16],
    },
  },
  {
    prefix: ['4'],
    type: {
      iconName: 'visa-credit',
      icon: visaCredit,
      cv2Length: 3,
      fixedLength: [13, 16],
    },
  },
];

const cardMap = {};

cardTypeByPrefixes.forEach((cardTypeByPrefix) => {
  cardTypeByPrefix.prefix.forEach((prefix) => {
    cardMap[prefix] = cardTypeByPrefix.type;
  });
});

export default (cardNumber) => {
  const result = Object.keys(cardMap).filter(prefix => cardNumber.startsWith(prefix));
  return result.length >= 1 ? cardMap[result[result.length - 1]] : defaultCardType;
};
